// External dependencies.
import $ from "jquery";

/**
 * RecipesCategoriesCarousel class.
 *
 * @since 0.9.0
 * @class RecipesCategoriesCarousel
 */
class RecipesCategoriesCarousel {
    /**
     * Creates an instance of RecipesCategoriesCarousel.
     * 
     * @since 0.9.0
     * @memberof RecipesCategoriesCarousel
     */
    constructor() {
        this.carousel = document.querySelector( '#recipes-categories-carousel' );
        this.initCarousel = this.initCarousel.bind( this );

        this.initCarousel();
    }

    initCarousel() {
        if ( !this.carousel ) {
            return;
        }

        const settings = {
            adaptiveHeight: true,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        dots: false,
                        arrows: true,
                        prevArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-left.png" class="ts-slider__arrow ts-slider__arrow--prev">`,
                        nextArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-right.png" class="ts-slider__arrow ts-slider__arrow--next">`,
                    }
                }
            ]
        };
        $( this.carousel ).slick( settings );
    }
}

export default RecipesCategoriesCarousel;
